/*
 * The cart drawer's celebration when the cart earns something free (Rune, 9 Oct 2026: keep
 * the cart as it is - only animate the "Yay! You get ..." text and add confetti).
 *
 * Where the drawer opens on add (every touch device; mouse devices outside the fly-to-cart
 * markets) the add-to-cart toast stays hidden, so this is the celebration there. When a free
 * gift lands - a new gift row, or a higher quantity on one - or free shipping is reached:
 *   - the text of the "Yay! You get ..." band opens out from its centre and the free items
 *     in it flash green (styles: assets/nb-cart-ladder.css, .nb-yay),
 *   - confetti bursts from that band, the same particles as the toast's,
 *   - the gift row that landed pops.
 * Nothing is added to the drawer and nothing in it moves. Something earned while the drawer
 * is shut plays if the cart is opened within a few seconds; after that the toast has shown it.
 *
 * Gift rows are read from the drawer (li.disable-free-item, .nb-gift-carab for the
 * carabiner), per slot rather than per variant so an out-of-stock fallback is not counted
 * as a new gift. Free shipping is read from the ladder (theme.nbGift.steps()) against the
 * bar's data-nb-paid. Loaded from sections/cart-drawer.liquid, only while its "NB12 test"
 * switch is on.
 */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer || (window.Shopify && Shopify.designMode)) return;

  var PENDING_MS = 8000;  // something earned with the drawer shut still plays this long
  var COOLDOWN_MS = 2500; // the optimistic row and the server render behind it are one gift
  var YAY_MS = 1700;      // length of the band's text animation (custom.css), re-applied across re-renders
  var COLOURS = ['#1f9d55', '#5fd893', '#f5c451', '#34c37a', '#0ea5a4', '#a3e635']; // as nb-cart-toast.js
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  var base = slots();
  var shipDone = shipReached(); // null until the gift engine has booted
  var pending = null; // { bag: bool, carab: bool, at: ms }
  var lastBurst = 0;
  var renderRaf = 0;
  var yayAt = 0;      // when the band's text animation started
  var yayTimer = 0;

  function isOpen() { return drawer.hasAttribute('open'); }

  function rows() {
    return Array.prototype.filter.call(drawer.querySelectorAll('li.disable-free-item'), function (li) {
      return li.style.display !== 'none'; // nb-free-gift hides rows going to 0
    });
  }

  function slotOf(li) { return li.classList.contains('nb-gift-carab') ? 'carab' : 'bag'; }

  // Units per slot. The input first: nb-free-gift's optimistic paint moves it before the render.
  function slots() {
    var s = { bag: 0, carab: 0 };
    rows().forEach(function (li) {
      var input = li.querySelector('input');
      var qty = parseInt((input && input.value) || li.getAttribute('data-quantity'), 10);
      s[slotOf(li)] += isNaN(qty) ? 1 : qty; // a row at 0 (optimistic removal) counts as 0, not 1
    });
    return s;
  }

  // Has the cart reached the free-shipping rung? null while the gift engine is not up yet,
  // so its late boot is not mistaken for the cart just getting there.
  function shipReached() {
    var steps = window.theme && theme.nbGift && theme.nbGift.steps ? theme.nbGift.steps() : null;
    if (!steps) return null;
    var ship = steps.filter(function (s) { return s.ship; })[0];
    var box = drawer.querySelector('.progress-bar-container[data-nb-paid]');
    var paid = box ? parseInt(box.getAttribute('data-nb-paid'), 10) || 0 : 0;
    return !!ship && paid >= ship.at;
  }

  // The band is re-rendered with the rest of the drawer: put the animation back where it
  // was (--nb-t is a negative delay) instead of letting it restart or vanish.
  function paintYay() {
    var band = drawer.querySelector('.free-shipping-reached');
    var since = Date.now() - yayAt;
    if (!band || !yayAt || since > YAY_MS) return;
    band.style.setProperty('--nb-t', -since + 'ms');
    band.classList.add('nb-yay');
  }

  function onRender() {
    var now = slots();
    var landed = { bag: now.bag > base.bag, carab: now.carab > base.carab, ship: false };
    base = now;
    var ship = shipReached();
    if (ship !== null) {
      landed.ship = shipDone !== null && ship && !shipDone;
      shipDone = ship;
    }
    paintYay();
    if (!landed.bag && !landed.carab && !landed.ship) return;
    pending = { bag: landed.bag || !!(pending && pending.bag), carab: landed.carab || !!(pending && pending.carab), at: Date.now() };
    if (isOpen()) play();
  }

  function play() {
    if (!pending || Date.now() - pending.at > PENDING_MS) { pending = null; return; }
    var what = pending;
    pending = null;
    if (Date.now() - lastBurst < COOLDOWN_MS) return;
    lastBurst = Date.now();
    // after the drawer has slid in and the band has laid out
    setTimeout(function () {
      if (!isOpen()) return;
      yayAt = Date.now();
      paintYay();
      clearTimeout(yayTimer);
      yayTimer = setTimeout(function () {
        yayAt = 0;
        var band = drawer.querySelector('.free-shipping-reached');
        if (band) band.classList.remove('nb-yay');
      }, YAY_MS);
      rows().filter(function (li) { return what[slotOf(li)]; }).forEach(function (li) {
        li.classList.remove('nb-gift-landed');
        void li.offsetWidth;
        li.classList.add('nb-gift-landed');
      });
      requestAnimationFrame(burst);
    }, 320);
  }

  // The drawer HTML is replaced on every cart render. Any element coming in counts - also a
  // render that leaves no gift rows (an emptied cart), or the next first gift would be
  // measured against the old cart. The delivery estimate rewrites a text node every frame;
  // text nodes are skipped.
  new MutationObserver(function (records) {
    var rendered = records.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && !n.classList.contains('nb-ladder__dot');
      });
    });
    if (!rendered || renderRaf) return;
    renderRaf = requestAnimationFrame(function () {
      renderRaf = 0;
      onRender();
    });
  }).observe(drawer, { childList: true, subtree: true });

  // nb-free-gift's optimistic paint raises a row's quantity without re-rendering it
  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(onRender, 250);
    setTimeout(onRender, 900);
  });

  new MutationObserver(function () {
    if (isOpen()) play();
  }).observe(drawer, { attributes: true, attributeFilter: ['open'] });

  // Same particle model as the toast's burst, from the "Yay!" band (or the bar above it when
  // this bag count has no band text), on a canvas over the drawer panel.
  function burst() {
    var panel = drawer.querySelector('.drawer__inner');
    var from = drawer.querySelector('.free-shipping-reached') || drawer.querySelector('.free-shipping-bar');
    if (!panel || !from || reduced.matches || document.hidden) return;
    var box = panel.getBoundingClientRect();
    var r = from.getBoundingClientRect();
    if (!box.width || !box.height || !r.width || !r.height) return;

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;z-index:40;pointer-events:none;left:' + box.left + 'px;top:' + box.top +
      'px;width:' + box.width + 'px;height:' + box.height + 'px';
    document.body.appendChild(canvas);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(box.width * dpr);
    canvas.height = Math.round(box.height * dpr);
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var COUNT = 130;
    var ox = r.left - box.left + r.width / 2;
    var oy = r.top - box.top + r.height / 2;
    var parts = [];
    for (var i = 0; i < COUNT; i++) {
      var angle = (i / COUNT) * Math.PI * 2 + (Math.random() - 0.5) * 0.28;
      var speed = (3 + Math.random() * 4) * (i % 2 === 0 ? 1 : 0.62);
      parts.push({
        x: ox + (Math.random() - 0.5) * r.width * 0.5,
        y: oy + (Math.random() - 0.5) * 10,
        vx: Math.cos(angle) * speed * 1.6,
        vy: Math.sin(angle) * speed - 1.5,
        size: 2.5 + Math.random() * 3,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.34,
        colour: COLOURS[(Math.random() * COLOURS.length) | 0]
      });
    }

    var DURATION = 1600;
    var SOLID = DURATION * 0.5;
    var started = null;
    function frame(now) {
      if (started === null) started = now;
      var t = now - started;
      ctx.clearRect(0, 0, box.width, box.height);
      if (t >= DURATION) { canvas.remove(); return; }
      var fade = t < SOLID ? 1 : 1 - (t - SOLID) / (DURATION - SOLID);
      parts.forEach(function (p) {
        p.vy += 0.1;
        p.vx *= 0.965;
        p.vy *= 0.985;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = Math.max(0, fade);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.colour;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 1.6);
        ctx.restore();
      });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
})();
